import EventActionIcon from "../../../assets/icons/EventActionIcon";
import React from "react";

type EarnTask = {
  id: string;
  title: string;
  subtitle: string;
  iconType: string;
};

type EarnCoinsTaskCardProps = {
  task: EarnTask;
  actionLabel: string;
  onAction: () => void;
};

const EarnCoinsTaskCard = ({
  task,
  actionLabel,
  onAction,
}: EarnCoinsTaskCardProps) => (
  <div className="earn-coins-card earn-coins-task">
    <div className="earn-coins-task__left">
      <div className="earn-coins-task__icon earn-coins-task__icon--event">
        <EventActionIcon type={task.iconType} />
      </div>
      <div className="earn-coins-task__text">
        <h4>{task.title}</h4>
        <p>{task.subtitle}</p>
      </div>
    </div>
    <button className="earn-coins-task__action" type="button" onClick={onAction}>
      {actionLabel}
    </button>
  </div>
);

export default EarnCoinsTaskCard;
